export let contacts = (state = contacts, action) => {
    switch (action.type) {
        case "REQUEST_CONTACTS":
            return {};
        case "RECEIVE_CONTACTS":
            return action.contacts;
        default:
            return state;
    }
};



// WEBPACK FOOTER //
// ./src/reducers/contacts.js